import React from 'react';
import { useTranslation } from 'react-i18next';
import './PaymentModal.scss';

const PaymentModal = ({ links, onClose }) => {
    const { t } = useTranslation();

    return (
        <div className="payment-modal-overlay" onClick={onClose}>
            <div className="payment-modal" onClick={e => e.stopPropagation()}>
                <button className="payment-modal-close" onClick={onClose}>✕</button>
                <h3>{t('payment.title')}</h3>
                <div className="payment-modal-options">
                    <a
                        href={links.stripe}
                        target="_blank"
                        rel="noreferrer"
                        className="payment-modal-btn stripe"
                        onClick={onClose}
                    >
                        <span className="payment-modal-icon">💳</span>
                        <div>
                            <span className="payment-modal-label">Stripe</span>
                            <span className="payment-modal-sub">{t('payment.stripe_sub')}</span>
                        </div>
                        <span className="payment-modal-arrow">→</span>
                    </a>
                    <div className="payment-modal-btn fedapay disabled">
                        <span className="payment-modal-icon">📱</span>
                        <div>
                            <span className="payment-modal-label">FedaPay</span>
                            <span className="payment-modal-sub">{t('payment.fedapay_sub')}</span>
                        </div>
                        <span className="payment-modal-soon">{t('payment.soon')}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentModal;
